export enum TypeOfChecklistEnum {
  CHECKLIST = "instance",
  TEMPLATE = "template",
}
